import React, { useEffect, useState, useMemo } from "react";
import { styles } from "../../../../helpers/pdfStyles";
import { useParams } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import moment from "moment";
// import IconQr from "../../../../assets/img/icon-qr.png";
import IconFatoratyFooter from "../../../../assets/img/fat-footer.png";
import * as invoiceActions from "../../../../_redux/invoices/invoicesActions";
import { Page, Text, View, Document, PDFViewer, Image, Font } from "@react-pdf/renderer";
import { generatePhase1QR, translateInvoicePdfData, translatePdfInvoiceStatus } from "../../../../helpers/helpers";
import QRCode from "qrcode";

const PdfInvoicePage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [productsDiscounts, setProductsDiscounts] = useState([]);
  const [invoiceData, setInvoiceData] = useState();
  const [companyData, setCompanyData] = useState();
  const [products, setProducts] = useState([]);
  const [filterTaxess, setFilterTaxess] = useState([]);
  const [isFontRegistered, setIsFontRegistered] = useState(false);
  //eslint-disable-next-line
  const [invoiceSummary, setInvoiceSummary] = useState({
    subtotal: 0,
    discount: 0,
    taxableAmount: 0,
    taxAmount: 0,
    allTaxAmount: 0,
    total: 0,
  });

  const { invoice } = useSelector(
    (state) => ({
      invoice: state?.invoices?.invoiceForEdit,
    }),
    shallowEqual,
  );
  useEffect(() => {
    if (id) {
      dispatch(invoiceActions.fetchInvoice(id));
    }
  }, [dispatch, id]);
  useEffect(() => {
    if (invoice) {
      setInvoiceData({ ...invoice });
      setCompanyData({ ...invoice?.company });
      setProducts([...invoice.invoiceData.products]);
    }
  }, [dispatch, invoice]);

  const filterTaxes = (products) => {
    if (products) {
      const allProductTaxes = [];
      for (let i = 0; i < products?.length; i++) {
        if (products[i] && products[i].taxes) {
          products[i].taxes.forEach((tax) => {
            allProductTaxes.push(tax);
          });
        }
      }
      let taxesUnique = [];
      const uniqueTaxesByProduct = [];
      //eslint-disable-next-line
      const uniqueArray = allProductTaxes.map((tax) => {
        const arr = allProductTaxes.filter((item) => item._id === tax._id);
        if (arr.length) {
          let includedValue = arr.reduce((a, b) => {
            return a + b.includedValue;
          }, 0);
          let excludedValue = arr.reduce((a, b) => {
            return a + b.exclusiveVaue;
          }, 0);
          taxesUnique = [...taxesUnique, arr];
          uniqueTaxesByProduct.push({ ...tax, includedValue, excludedValue });
        }
      });
      const newuniqueArray = uniqueTaxesByProduct.filter(function(value, index, self) {
        return index === self.findIndex((t) => t._id === value._id);
      });

      return newuniqueArray?.length ? newuniqueArray : allProductTaxes;
    }
  };

  ///// products discount /////
  useEffect(() => {
    let totalDiscount = [];
    if (invoice?.invoiceData?.products) {
      invoice.invoiceData.products.forEach((product) => {
        return product.discounts?.forEach((discount) => {
          return discount?.type
            ? discount.type === "%"
              ? totalDiscount.push({ name: product?.name, value: (+discount.value * +product.totalPrice) / 100 })
              : totalDiscount.push({ name: product?.name, value: discount?.value })
            : totalDiscount.push({ name: product?.name, value: 0 });
        });
      });
    }
    setProductsDiscounts([...totalDiscount]);
    //eslint-disable-next-line
  }, [invoice?.invoiceData?.products]);

  ///// products tax /////
  // useEffect(() => {
  //   let totalTax = [];

  //   if (products && productsDiscounts && productsDiscounts?.length) {
  //     products.forEach((product, index) => {
  //       return product?.vat && product?.rate === "basic"
  //         ? totalTax.push(((+product?.price * +product?.quantity - productsDiscounts[index]) * +companyData?.taxRate) / 100)
  //         : totalTax.push(0);
  //     });
  //   }
  //   setProductsTax([...totalTax]);
  //   // eslint-disable-next-line
  // }, [products, productsDiscounts]);

  useEffect(() => {
    let subtotalP = 0;
    let totalD = 0;
    let taxAmount = 0;
    let allTaxAmount = 0;

    if (products && products?.length) {
      ///// Subtotal ////
      subtotalP = products?.reduce((a, b) => {
        return (subtotalP = a + +b.price * +b?.quantity);
      }, 0);

      ///// Discount ////
      totalD = products?.reduce((a, b) => {
        if (b.discount) {
          return (totalD = a + +b.discount);
        } else {
          return totalD;
        }
      }, 0);

      //  Added Tax
      taxAmount = products?.reduce((a, b) => {
        if (b?.addedTax) {
          return (taxAmount = a + b?.addedTax);
        } else {
          return taxAmount;
        }
      }, 0);
      // Total Tax
      allTaxAmount = products?.reduce((a, b) => {
        if (b?.tax) {
          return (allTaxAmount = a + +b?.tax);
        } else {
          return allTaxAmount;
        }
      }, 0);
    }
    setInvoiceSummary({
      subtotal: subtotalP,
      discount: totalD,
      taxableAmount: subtotalP - totalD,
      taxAmount: taxAmount,
      allTaxAmount: allTaxAmount,
      total: subtotalP - totalD + taxAmount,
    });
  }, [invoiceData, products, companyData]);

  function calculateDiscounts(products) {
    const discountsMap = {};
    if (products) {
      products.forEach((product) => {
        const quantity = product.quantity || 1; // Default to 1 if quantity is not provided
        let remainingPrice = product.price * quantity; // Start with the total price

        product.discounts.forEach((discount) => {
          // if (discount.isSelected) {
          const key = discount.name;
          if (!discountsMap[key]) {
            discountsMap[key] = 0;
          }

          let discountValue = 0;
          if (discount.type === "%") {
            discountValue = parseFloat((discount.value * remainingPrice) / 100); // Apply percentage discount
          } else {
            discountValue = parseFloat(discount.value); // Apply fixed discount
          }

          discountsMap[key] += discountValue; // Add to the map
          remainingPrice -= discountValue; // Deduct this discount from the remaining price
          // }
        });
      });
    }
    return discountsMap;
  }
  const aggregatedDiscounts = calculateDiscounts(invoice?.invoiceData?.products || []);

  const filteredTaxes = filterTaxes(invoice?.invoiceData?.products || []);
  useEffect(() => {
    if (products) {
      let includedTaxes = filterTaxes(products?.flat());
      setFilterTaxess([...includedTaxes]);
    }
  }, [products]);

  const registerFont = () => {
    Font.register({
      family: "NotoSansArabic",
      src: "https://cdn.jsdelivr.net/gh/googlefonts/noto-fonts@main/hinted/ttf/NotoSansArabic/NotoSansArabic-Regular.ttf",
    });
    setIsFontRegistered(true);
  };

  useEffect(() => {
    registerFont();
  }, []);

  Font.registerHyphenationCallback((word) => [word]);

  const getZatcaQrImage = async (tlvString) => {
    try {
      // This produces a real PNG image, not just data
      const imageBase64 = await QRCode.toDataURL(tlvString, {
        width: 200,
        margin: 1,
        errorCorrectionLevel: "M", // ZATCA standard
      });

      return imageBase64;
    } catch (err) {
      console.error("QR Image Generation Error:", err);
      return null;
    }
  };

  const [qrImage, setQrImage] = useState("");

  useEffect(() => {
    const invoiceData = invoice?.invoiceData;
    const storeData = invoiceData?.senderInformation?.storeData;
    const generateImage = async () => {
      // 1. Generate the raw TLV string using your current code
      const tlvData = generatePhase1QR(invoiceData, storeData);

      // 2. Convert that string into a visual PNG
      const pngImage = await getZatcaQrImage(tlvData);

      // 3. Save to state
      setQrImage(pngImage);
    };

    if (invoiceData && storeData) {
      generateImage();
    }
  }, [invoice]);

  let refactoredStore = {
    name: invoice?.invoiceData?.senderInformation?.storeData?.name,
    taxNumber: invoice?.invoiceData?.senderInformation?.storeData?.taxNumber,
    address: invoice?.invoiceData?.senderInformation?.storeData?.address,
    image: invoice?.invoiceData?.senderInformation?.storeData?.image,
    footerInfo: invoice?.invoiceData?.senderInformation?.storeData?.description,
    headerInfo: invoice?.invoiceData?.senderInformation?.storeData?.storeDetails,
    showProductComments: invoice?.invoiceData?.senderInformation?.storeData?.showNotes,
  };
  const isArabic = (text) => /[\u0600-\u06FF]/.test(text);
  return useMemo(
    () => (
      <>
        {invoiceData?.invoiceData && companyData && productsDiscounts && filteredTaxes && filterTaxess && isFontRegistered && refactoredStore && (
          <PDFViewer style={{ height: "100%" }}>
            <Document>
              <Page style={[styles.page, { fontFamily: "NotoSansArabic", paddingBottom: "60" }]} size="A4" wrap={true}>
                <View
                  style={[
                    styles.row,
                    {
                      flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                      textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right",
                    },
                  ]}
                >
                  <View style={[styles.col_4]}>
                    <Text style={[styles.textBold]}>{refactoredStore?.name ? refactoredStore?.name : ""} </Text>
                    {/* <Text style={[styles.infoText]}>{refactoredStore?.address ? refactoredStore?.address : ""}</Text> */}
                    <Text style={[styles.infoText, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                      {refactoredStore?.taxNumber
                        ? `${
                            invoice?.selectedInvoiceLanguage === "en"
                              ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.taxId
                              : ` الرقم الضريبي :`
                          } ${refactoredStore?.taxNumber}`
                        : ""}
                    </Text>

                    {/* <Text style={[styles.infoText]}>{companyData?.mobile ? companyData?.mobile : ""}</Text>
                    <Text style={[styles.infoText]}>{companyData?.email ? companyData?.email : ""}</Text>
                    <Text style={[styles.infoText]}>{companyData?.city ? companyData?.city : ""}</Text> */}
                  </View>
                  <View style={[styles.col_2, { display: "flex", justifyContent: "center", alignItems: "center" }]}>
                    {/* {refactoredStore?.taxNumber ? ( */}
                    {invoice?.zatca?.qrCode?.length > 0 ? (
                      <>
                        <Image style={[styles.qrCode]} src={invoice?.zatca?.qrCode} />
                      </>
                    ) : invoice?.invoiceData?.senderInformation?.storeData?.taxNumber ? (
                      <>
                        <Image style={[styles.qrCode]} src={qrImage} />
                      </>
                    ) : (
                      <Text></Text>
                    )}
                  </View>
                  <View
                    style={[
                      styles.col_4,
                      {
                        marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "6" : "0",
                        marginRight: invoice?.selectedInvoiceLanguage === "ar" ? "6" : "0",
                      },
                    ]}
                  >
                    {refactoredStore?.image?.length > 0 ? (
                      <>
                        <Image style={[styles.companyLogo]} src={refactoredStore?.image} />
                      </>
                    ) : (
                      <Text></Text>
                    )}
                  </View>
                </View>
                <View style={[styles.row, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]}>
                  <View style={[styles.col_4]}>
                    <Text style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                      {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.customerInformation}{" "}
                    </Text>
                    {/* to include in standard tax invoice */}

                    {/* {refactoredStore?.taxNumber?.length > 0 ? (
                      <>
                        <View
                          style={[
                            styles.blockInfoRow,
                            {
                              flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                              justifyContent: "space-between",
                              lineHeight: "1.2",
                            },
                          ]}
                        >
                          <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.taxId}</Text>
                          <Text
                            style={[
                              styles.blockInfoText,
                              {
                                marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                                marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                              },
                            ]}
                          >
                            {invoice?.invoiceData?.receiverInformation?.taxNumber}
                          </Text>
                        </View>
                        <View
                          style={[
                            styles.blockInfoRow,
                            {
                              flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                              justifyContent: "space-between",
                              lineHeight: "1.2",
                            },
                          ]}
                        >
                          <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.businessName}</Text>
                          <Text
                            style={[
                              styles.blockInfoText,
                              {
                                marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                                marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                              },
                            ]}
                          >
                            {invoice?.invoiceData?.receiverInformation?.businessName}
                          </Text>
                        </View>
                      </>
                    ) : (
                      <Text></Text>
                    )} */}

                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.customerName}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                          },
                        ]}
                      >
                        {/* {invoiceData?.invoiceData?.customerName
                          ? invoiceData?.invoiceData?.customerName?.first + " " + invoiceData?.invoiceData?.customerName?.last
                          : invoiceData?.invoiceData?.receiverInformation?.name &&
                            invoiceData?.receiverInformation?.name?.first?.length > 0 &&
                            invoiceData?.receiverInformation?.name?.last?.length > 0
                          ? invoiceData?.invoiceData?.receiverInformation?.name?.first + " " + invoiceData?.receiverInformation?.name?.last
                          : ""} */}
                        {invoice?.invoiceData?.customerName?.length > 0 && invoice?.invoiceData?.customerName?.first
                          ? invoice?.invoiceData?.customerName?.first + " " + invoice?.invoiceData?.customerName?.last
                          : invoice?.invoiceData?.receiverInformation?.name
                          ? invoice?.invoiceData?.receiverInformation?.name?.first + " " + invoice?.invoiceData?.receiverInformation?.name?.last
                          : ""}
                      </Text>
                    </View>

                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.email}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                          },
                        ]}
                      >
                        {invoiceData?.invoiceData?.customerEmail?.length > 0
                          ? invoiceData?.invoiceData?.customerEmail
                          : invoiceData?.invoiceData?.receiverInformation?.email?.length > 0
                          ? invoiceData?.invoiceData?.receiverInformation?.email
                          : ""}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.mobile}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                          },
                        ]}
                      >
                        {invoice?.invoiceData?.receiverInformation?.mobile}
                      </Text>
                    </View>
                  </View>
                  <View style={[styles.col_2]}>
                    <Text style={{ textAlign: "center", fontSize: "13", lineHeight: invoice?.selectedInvoiceLanguage === "en" ? "1.8" : "1.6" }}>
                      {/* {invoiceData?.invoiceData?.invoiceType === "refund" && invoice?.company?.taxNumber?.length === 0 */}
                      {invoice?.invoiceData?.invoiceType === "refund" && refactoredStore?.taxNumber?.length === 0
                        ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.refund
                        : invoice?.invoiceData?.invoiceType === "refund" && refactoredStore?.taxNumber?.length > 0
                        ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.creditNoteInvoice
                        : refactoredStore?.taxNumber?.length > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                        ? // ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.taxInvoice
                          // translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.simplifiedTaxInvoice
                          invoice?.selectedInvoiceLanguage === "en"
                          ? "Simplified Tax"
                          : "فاتورة ضريبية"
                        : translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.invoice}
                    </Text>
                    {refactoredStore?.taxNumber?.length > 0 && invoice?.invoiceData?.invoiceType !== "refund" ? (
                      <Text style={{ textAlign: "center", fontSize: "13" }}>{invoice?.selectedInvoiceLanguage === "en" ? "Invoice" : "مبسطة"}</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </View>
                  <View style={[styles.col_4]}>
                    <Text style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                      {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.invoiceInformation}
                    </Text>
                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.number}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                          },
                        ]}
                      >
                        {invoice?.invoiceData?.invoiceNumber}
                      </Text>
                    </View>
                    {invoice?.invoiceData?.invoiceType === "refund" && refactoredStore?.taxNumber?.length > 0 ? (
                      <View
                        style={[
                          styles.blockInfoRow,
                          {
                            flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                            justifyContent: "space-between",
                            lineHeight: "1.2",
                          },
                        ]}
                      >
                        <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.parentInvoiceNo} </Text>
                        <Text
                          style={[
                            styles.blockInfoText,
                            {
                              marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                              marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                            },
                          ]}
                        >
                          {invoice?.invoiceData?.parentinvoiceNumber}
                        </Text>
                      </View>
                    ) : (
                      <Text></Text>
                    )}

                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.date}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                          },
                        ]}
                      >
                        {moment(invoiceData?.invoiceData?.invoiceDate).format("MM/DD/YYYY")}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          alignItems: "center",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.status}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                            marginTop: invoice?.selectedInvoiceLanguage === "en" ? "7px" : "0px",
                          },
                        ]}
                      >
                        {/* {invoiceData?.status?.charAt(0)?.toUpperCase() + invoiceData?.status?.slice(1)} */}
                        {translatePdfInvoiceStatus(invoiceData?.status, invoice?.selectedInvoiceLanguage)}
                      </Text>
                    </View>
                    <View
                      style={[
                        styles.blockInfoRow,
                        {
                          flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                          justifyContent: "space-between",
                          alignItems: "center",
                          lineHeight: "1.2",
                        },
                      ]}
                    >
                      <Text style={[styles.blockInfoLabel]}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.type}</Text>
                      <Text
                        style={[
                          styles.blockInfoText,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "5px" : "auto",
                            marginRight: invoice?.selectedInvoiceLanguage === "en" ? "auto" : "5px",
                            marginTop: invoice?.selectedInvoiceLanguage === "en" ? "7px" : "0px",
                          },
                        ]}
                      >
                        {invoiceData?.invoiceData?.invoiceType === "sale"
                          ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.sales
                          : invoiceData?.invoiceData?.invoiceType === "refund"
                          ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.refund
                          : ""}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* invoice notes header info  */}

                {refactoredStore?.headerInfo?.length > 0 ? (
                  <View style={[styles.row, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]} wrap={false}>
                    <View style={[styles.border, { width: "100%" }]}>
                      <View style={[styles.blockInfoRow]}>
                        <Text style={[styles.footerInfo, { textAlign: isArabic(refactoredStore?.headerInfo) ? "right" : "left" }]}>
                          {refactoredStore?.headerInfo}
                        </Text>
                      </View>
                    </View>
                  </View>
                ) : (
                  <Text></Text>
                )}

                <View style={[styles.table]}>
                  <View
                    style={[
                      styles.tableRow,
                      styles.tableBorderTop,
                      {
                        flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                        textAlign: invoice?.selectedInvoiceLanguage === "ar" ? "right" : "left",
                      },
                    ]}
                  >
                    {/* <View style={styles.tableColHeaderNumber}>
                      <Text style={styles.tableCellHeader}></Text>
                    </View> */}
                    <View
                      style={
                        // Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                        //   ? styles.tableColHeaderLarge
                        //   : styles.tableColSlightLarge
                        // refactoredStore?.taxNumber?.length > 0 ? styles.tableColMuchLarge : styles.tableColSlightLarge
                        styles.tableColMuchLarge
                      }
                    >
                      <Text style={styles.tableCellHeader}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.itemName}</Text>
                      <Text style={[styles.tableCellHeader, styles.shortText]}>
                        {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.description}
                      </Text>
                    </View>
                    {/* <View style={styles.tableColHeaderLarge}>
                      <Text style={styles.tableCellHeader}>Item Desc.</Text>
                    </View> */}
                    <View
                      style={
                        Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                          ? styles.tableColHeaderSmall
                          : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                          ? styles.tableColHeaderBitSmall
                          : // : styles.tableColHeaderCustom
                            styles.tableColHeaderSmall
                      }
                    >
                      <Text style={styles.tableCellHeader}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.unitPrice}</Text>
                    </View>
                    <View
                      style={
                        Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                          ? styles.tableColHeaderSmall
                          : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                          ? styles.tableColHeaderBitSmall
                          : // : styles.tableColHeaderCustom
                            styles.tableColHeaderSmall
                      }
                    >
                      <Text style={styles.tableCellHeader}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.units}</Text>
                    </View>

                    {refactoredStore?.taxNumber?.length === 0 &&
                    Number(invoice?.invoiceData?.discountTotal) > 0 &&
                    invoice?.invoiceData?.invoiceType !== "refund" ? (
                      // <View style={styles.tableColHeaderCustom}>
                      <View style={styles.tableColHeaderBitSmall}>
                        <Text style={styles.tableCellHeader}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.subTotal}</Text>
                      </View>
                    ) : (
                      <View></View>
                    )}

                    {/* hide from simplified tax invoice and credit notes */}

                    {refactoredStore?.taxNumber?.length === 0 &&
                    Number(invoice?.invoiceData?.discountTotal) > 0 &&
                    invoice?.invoiceData?.invoiceType !== "refund" ? (
                      <View
                        style={
                          Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                            ? styles.tableColHeaderSmall
                            : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                            ? styles.tableColHeaderBitSmall
                            : // : styles.tableColHeaderCustom
                              styles.tableColHeaderSmall
                        }
                      >
                        <Text style={styles.tableCellHeader}>{translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.disc}</Text>
                      </View>
                    ) : (
                      <View></View>
                    )}

                    {/* show for standard tax invoice */}

                    {/* {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                      <View style={styles.tableColHeaderMedium}>
                        <Text style={[styles.tableCellHeader, { fontSize: 8 }]}>
                          {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.totalBeforeTax}
                        </Text>
                      </View>
                    ) : (
                      <View style={[styles.tableColHeaderCustom]}>
                        <Text style={[styles.tableCellHeader, { fontSize: 8, textAlign: "right" }]}>
                          {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.total}
                        </Text>
                      </View>
                    )} */}

                    <View
                      style={[
                        Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                          ? styles.tableColHeaderBitSmall
                          : // : styles.tableColHeaderCustom,
                            styles.tableColHeaderSmall,
                      ]}
                    >
                      <Text style={[styles.tableCellHeader, { fontSize: 8, textAlign: "right" }]}>
                        {refactoredStore?.taxNumber?.length > 0
                          ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.totalText
                          : translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.total}
                      </Text>
                    </View>

                    {/* show for standard tax invoice */}

                    {/* {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                      <View style={{}}>
                        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                          {filteredTaxes?.map((tax, index) => {
                            return (
                              <View style={(styles.tableColHeaderSlightSmall, styles.tableFlex)}>
                                <Text style={[styles.tableCellHeaderWithFixWidth, { fontSize: 8 }]}>{`${tax?.name} ${
                                  tax?.type !== "Added to the price"
                                    ? `(${tax?.taxRate}% ${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.inclusive})`
                                    : `${tax?.taxRate}%`
                                }`}</Text>
                              </View>
                            );
                          })}
                        </View>
                      </View>
                    ) : (
                      <Text></Text>
                    )} */}

                    {/* <View style={styles.tableColHeader}>
                      <Text style={styles.tableCellHeader}>Taxable Amount</Text>
                    </View> */}
                    {/* <View style={styles.tableColHeader}>
                      <Text style={styles.tableCellHeader}>Tax Rates</Text>
                    </View>
                    <View style={styles.tableColHeaderMedium}>
                      <Text style={styles.tableCellHeader}>Tax Amount</Text>
                    </View> */}

                    {/* show for standard tax invoice */}

                    {/* {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                      <View style={styles.tableColHeaderLarge}>
                        <Text style={[styles.tableCellHeader, { fontSize: 8, textAlign: "right" }]}>
                          {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.totalWithTax}
                        </Text>
                      </View>
                    ) : (
                      <Text></Text>
                    )} */}
                  </View>

                  <View style={[styles.tableBorderTop]}>
                    {invoice?.invoiceData?.products?.map((item, index) => {
                      //eslint-disable-next-line
                      let totalPrice = 0;
                      let taxes = item?.taxes && item?.taxes?.filter((tax) => tax?.type === "Added to the price");
                      if (taxes?.length > 0) {
                        taxes.forEach((tax) => {
                          totalPrice += tax?.exclusiveVaue;
                        });
                      }
                      let subTotal = (Number(item?.price)?.toFixed(2) * Number(item?.quantity)?.toFixed(2))?.toFixed(2);
                      // let discount = item?.totalDiscountOnProduct ? Number(item?.totalDiscountOnProduct)?.toFixed(2) : "0.0";
                      let discount = productsDiscounts && productsDiscounts?.find((discount) => discount?.name === item?.name)?.value;
                      return (
                        <View
                          style={[
                            styles.tableRow,
                            {
                              flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                              textAlign: invoice?.selectedInvoiceLanguage === "ar" ? "right" : "left",
                            },
                          ]}
                        >
                          {/* <View style={styles.tableColNumber}>
                            <Text style={styles.tableCell}></Text>
                          </View> */}
                          <View
                            style={
                              // Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                              //   ? styles.tableColLarge
                              //   : styles.tableColHeaderSlightLarge
                              // refactoredStore?.taxNumber?.length > 0 ? styles.tableColHeaderMuchLarge : styles.tableColHeaderSlightLarge
                              styles.tableColMuchLarge
                            }
                          >
                            <Text style={(styles.tableCell, styles.tableCellHeader)}>
                              {item?.name ? item.name : item?.englishName ? item?.englishName : ""}
                            </Text>
                            <Text style={[styles.productDesriptionText, styles.shortText]}>
                              {refactoredStore?.showProductComments && item?.invoicecomment ? item.invoicecomment : ""}
                            </Text>
                            <Text style={[styles.productDescriptionText, styles.shortText]}>{item?.englishDetail ? item.englishDetail : ""}</Text>
                          </View>

                          <View
                            style={
                              Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                                ? styles.tableColSmall
                                : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                                ? styles.tableColABitSmall
                                : // : styles.tableColCustom
                                  styles.tableColSmall
                            }
                          >
                            <Text style={styles.tableCell}>{Number(item?.price)?.toFixed(2)}</Text>
                          </View>
                          <View
                            style={
                              Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                                ? styles.tableColSmall
                                : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                                ? styles.tableColABitSmall
                                : // : styles.tableColCustom
                                  styles.tableColSmall
                            }
                          >
                            <Text style={styles.tableCell}>{item?.quantity}</Text>
                          </View>

                          {refactoredStore?.taxNumber?.length === 0 &&
                          Number(invoice?.invoiceData?.discountTotal) > 0 &&
                          invoice?.invoiceData?.invoiceType !== "refund" ? (
                            // <View style={styles.tableColCustom}>
                            <View style={styles.tableColABitSmall}>
                              <Text style={styles.tableCell}>
                                {(Number(item?.price)?.toFixed(2) * Number(item?.quantity)?.toFixed(2))?.toFixed(2)}
                              </Text>
                            </View>
                          ) : (
                            <View></View>
                          )}

                          {/* hide from simplified tax invoice and credit notes */}

                          {refactoredStore?.taxNumber?.length === 0 &&
                          Number(invoice?.invoiceData?.discountTotal) > 0 &&
                          invoice?.invoiceData?.invoiceType !== "refund" ? (
                            <View
                              style={
                                Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                                  ? styles.tableColSmall
                                  : Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                                  ? styles.tableColABitSmall
                                  : // : styles.tableColCustom
                                    styles.tableColSmall
                              }
                            >
                              <Text style={styles.tableCell}>{discount ? Number(discount)?.toFixed(2) : "0.00"}</Text>
                            </View>
                          ) : (
                            <View></View>
                          )}

                          {/* to show for standard tax invoice */}

                          {/* {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                            <View style={[styles.tableColMedium]}>
                              <Text style={styles.tableCell}>{Number(+item?.totalPrice)?.toFixed(2)}</Text>
                            </View>
                          ) : (
                            <View style={[styles.tableColCustom, { textAlign: "right" }]}>
                              <Text style={styles.tableCell}>{Number(+item?.totalPrice)?.toFixed(2)} </Text>
                            </View>
                          )} */}

                          <View
                            style={[
                              Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                                ? styles.tableColABitSmall
                                : // : styles.tableColCustom,
                                  styles.tableColSmall,
                              { textAlign: "right" },
                            ]}
                          >
                            <Text style={styles.tableCell}>
                              {Number(invoice?.invoiceData?.discountTotal) > 0 && invoice?.invoiceData?.invoiceType !== "refund"
                                ? discount
                                  ? (Number(subTotal) - Number(discount))?.toFixed(2)
                                  : Number(subTotal).toFixed(2)
                                : Number(+item?.totalPrice)?.toFixed(2)}{" "}
                            </Text>
                          </View>

                          {/* to show for standard tax invoice */}

                          {/* {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                            <View style={{}}>
                              <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                                {filteredTaxes?.map((tax, index) => {
                                  return (
                                    <View style={(styles.tableColSlightSmall, styles.tableFlex)}>
                                      <Text style={[styles.tableFixedWidthCell, { fontSize: 8 }]}>
                                        {Number(tax?.includedValue) > 0 ? tax?.taxRate + "%" : Number(tax?.exclusiveVaue)?.toFixed(2)}
                                      </Text>
                                    </View>
                                  );
                                })}
                              </View>
                            </View>
                          ) : (
                            <Text></Text>
                          )} */}
                          {/* to show for standard tax invoice */}

                          {/* 
                          {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                            <View style={[styles.tableColLarge, { textAlign: "right" }]}>
                              <Text style={[styles.tableCell]}>{Number(+item?.totalPrice + +totalPrice)?.toFixed(2)}</Text>
                            </View>
                          ) : (
                            <Text></Text>
                          )} */}
                        </View>
                      );
                    })}
                  </View>
                  <View style={[styles.tableBorderBot]}></View>
                </View>

                <View
                  style={[styles.row, { marginTop: "20", flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]}
                  wrap={false}
                >
                  <View style={[styles.col_4]}>
                    <Text style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                      {invoice?.selectedInvoiceLanguage === "ar" && ` (${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.sar}) `}
                      {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.payments}
                      {invoice?.selectedInvoiceLanguage === "en" && ` (${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.sar})`}
                    </Text>
                    <View style={[styles.border, { lineHeight: "1.2" }]}>
                      <View style={[styles.blockPaymentRow, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]}>
                        <Text style={styles.blockPaymentTitleText}>
                          {invoiceData?.status?.charAt(0)?.toUpperCase() + invoiceData?.status?.slice(1)}
                        </Text>
                        <Text style={styles.blockPaymentTitleText}>
                          {/* {invoice?.invoiceData?.payments?.length > 1
                            ? Number(invoice?.invoiceData?.totalaftertax)?.toFixed(2)
                            : invoiceData?.invoiceData?.paidTotal
                            ? Number(invoiceData?.invoiceData?.paidTotal)?.toFixed(2)
                              : 0} */}

                          {invoice?.invoiceData?.invoiceType !== "refund"
                            ? invoice?.invoiceData?.totalaftertax && Number(invoice?.invoiceData?.totalaftertax)?.toFixed(2)
                            : Number(invoice?.invoiceData?.paidTotal).toFixed(2)}
                        </Text>
                      </View>
                      {invoiceData?.invoiceData?.payments?.map((payments) => {
                        return (
                          <View
                            style={[
                              styles.blockPaymentRow,
                              { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse", lineHeight: "1.2" },
                            ]}
                          >
                            <Text style={styles.blockPaymentText}>{moment(payments.createdAt).format("MM/DD/YYYY")}</Text>
                            <Text style={styles.blockPaymentText}>
                              {payments?.method === "visa/master_card"
                                ? "Master/Visa Card"
                                : payments.method === "mada_card"
                                ? "Mada Card"
                                : payments.method === "bank_transfer"
                                ? "Bank "
                                : payments.method === "cash" || payments.method === "Cash"
                                ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.cash
                                : payments.method === "Card" || payments.method === "card"
                                ? "Card"
                                : payments?.method}
                            </Text>
                            <Text style={styles.blockPaymentText}>
                              {invoice?.invoiceData?.invoiceType === "refund" && Number(payments?.amount) > Number(invoice?.invoiceData?.paidTotal)
                                ? invoice?.invoiceData?.paidTotal
                                  ? Number(invoice?.invoiceData?.paidTotal)?.toFixed(2)
                                  : 0.0
                                : invoiceData?.invoiceData?.payments?.length === 1
                                ? Number(invoice?.invoiceData?.totalaftertax)?.toFixed(2)
                                : Number(payments?.amount)?.toFixed(2)}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                    <View style={[styles.border, { lineHeight: "1.2" }]}>
                      <View style={[styles.blockPaymentRow, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]}>
                        <Text style={styles.blockPaymentTitleText}> {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.balanceDue}</Text>
                        <Text style={styles.blockPaymentTitleText}>
                          {invoiceData?.invoiceData?.balance ? Number(invoiceData?.invoiceData?.balance)?.toFixed(2) : 0}
                        </Text>
                      </View>
                      <View
                        style={[
                          styles.blockPaymentRow,
                          { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse", lineHeight: "1.2" },
                        ]}
                      >
                        <Text style={styles.blockPaymentText}> {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.dueDate}</Text>
                        <Text style={styles.blockPaymentText}>
                          {invoiceData?.invoiceData?.dueDate && invoiceData?.invoiceData?.dueDate !== "Invalid date"
                            ? moment(invoiceData?.invoiceData?.dueDate).format("MM/DD/YYYY")
                            : ""}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.col_2}></View>
                  <View style={[styles.col_4]}>
                    <Text style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                      {invoice?.selectedInvoiceLanguage === "ar" && ` (${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.sar}) `}
                      {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.total}
                      {invoice?.selectedInvoiceLanguage === "en" && ` (${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.sar})`}
                    </Text>
                    {Number(invoice?.invoiceData?.discountTotal) > 0 ? (
                      <View
                        style={[
                          (styles.blockBorderRow, styles.blockPaymentRow),
                          { lineHeight: "1.2", flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" },
                        ]}
                      >
                        <Text style={(styles.blockPaymentTitleText, styles.boldText)}>
                          {" "}
                          {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.subTotal}
                        </Text>
                        <Text style={(styles.blockPaymentTitleText, styles.boldText)}>
                          {invoice?.invoiceData?.productsTotal ? Number(invoice?.invoiceData?.productsTotal)?.toFixed(2) : 0.0}
                        </Text>
                      </View>
                    ) : (
                      <Text></Text>
                    )}

                    {Number(invoice?.invoiceData?.discountTotal) > 0 ? (
                      <View style={{}}>
                        {Object.keys(aggregatedDiscounts).map((discountName, index) => {
                          const totalDiscount = aggregatedDiscounts[discountName];
                          return (
                            <View
                              style={[
                                styles.blockBorderRow,
                                styles.blockPaymentRow,
                                {
                                  display: "flex",
                                  flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                                  lineHeight: "1.2",
                                  justifyContent: "space-between",
                                },
                              ]}
                            >
                              <Text style={styles.blockPaymentTitleText}>{discountName}</Text>
                              <Text style={styles.blockPaymentTitleText}>-{parseFloat(totalDiscount).toFixed(2)}</Text>
                            </View>
                          );
                        })}
                      </View>
                    ) : (
                      <Text></Text>
                    )}
                    {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                      <View
                        style={[
                          styles.blockPaymentRow,
                          { lineHeight: "1.2", flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" },
                        ]}
                      >
                        <Text style={(styles.blockPaymentTitleText, styles.boldText)}>
                          {" "}
                          {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.totalBeforeTax}
                        </Text>
                        <Text style={(styles.blockPaymentTitleText, styles.boldText)}>
                          {invoice?.invoiceData?.totalbeforetax ? Number(invoice?.invoiceData?.totalbeforetax)?.toFixed(2) : 0.0}
                        </Text>
                      </View>
                    ) : (
                      <Text></Text>
                    )}

                    {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0 ? (
                      <View style={{}}>
                        {/* {invoiceData?.invoiceData?.products?.map((product, index) => {
                          return ( */}
                        <View>
                          {filteredTaxes?.map((tax, index) => {
                            return (
                              <View
                                style={[
                                  styles.blockBorderRow,
                                  styles.blockPaymentRow,
                                  {
                                    display: "flex",
                                    flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse",
                                    justifyContent: "space-between",
                                    lineHeight: "1.2",
                                  },
                                ]}
                              >
                                <Text style={styles.blockPaymentTitleText}>{`${tax?.name} ${tax?.taxRate}% ${
                                  tax?.type !== "Added to the price"
                                    ? `(${translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.inclusive})`
                                    : ""
                                }`}</Text>

                                <Text style={styles.blockPaymentTitleText}>
                                  {" "}
                                  {Number(tax?.includedValue) > 0 ? Number(tax?.includedValue)?.toFixed(2) : Number(tax?.excludedValue)?.toFixed(2)}
                                </Text>
                              </View>
                            );
                          })}
                        </View>
                        {/* );
                        })} */}
                      </View>
                    ) : (
                      <Text></Text>
                    )}
                    <View
                      style={[
                        styles.blockPaymentRow,
                        { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse", lineHeight: "1.2" },
                      ]}
                    >
                      {/* show for standard tax invoice */}

                      {/* <Text style={(styles.blockPaymentTitleText, { fontWeight: "bold" })}>
                        {Number(invoice?.invoiceData?.taxTotal) > 0 || filterTaxess?.length > 0
                          ? translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.totalWithTax
                          : translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.total}
                      </Text> */}

                      <Text style={(styles.blockPaymentTitleText, { fontWeight: "bold" })}>
                        {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.total}
                      </Text>

                      <Text style={(styles.blockPaymentTitleText, { fontWeight: "bold" })}>
                        {" "}
                        {invoice?.invoiceData?.invoiceType !== "refund"
                          ? invoice?.invoiceData?.totalaftertax && Number(invoice?.invoiceData?.totalaftertax)?.toFixed(2)
                          : Number(invoice?.invoiceData?.paidTotal).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                </View>
                {/* <View style={[styles.termsAndCond]}>
                    <View
                      style={[styles.termsRow, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]}
                      wrap={false}
                    >
                      {/* <View style={[styles.col_3]}> */}
                {/* <View style={{ width: "100%" }}>
                        <View style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                          <Text> {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.replacementPolicy}</Text>
                        </View>
                      </View> */}
                {/* <View
                        style={[
                          styles.col_3_5,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "15" : "0",
                            marginRight: invoice?.selectedInvoiceLanguage === "ar" ? "15" : "0",
                          },
                        ]}
                      >
                        <View style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                          <Text> {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.note}</Text>
                        </View>
                      </View>
                      <View
                        style={[
                          styles.col_3,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "15" : "0",
                            marginRight: invoice?.selectedInvoiceLanguage === "ar" ? "15" : "0",
                          },
                        ]}
                      >
                        <View style={[styles.blockTitle, { textAlign: invoice?.selectedInvoiceLanguage === "en" ? "left" : "right" }]}>
                          <Text> {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.termsAndCond}</Text>
                        </View>
                      </View> */}
                {/* </View> */}
                {refactoredStore?.footerInfo?.length > 0 ? (
                  <View style={[styles.row, { flexDirection: invoice?.selectedInvoiceLanguage === "en" ? "row" : "row-reverse" }]} wrap={false}>
                    <View style={[styles.border, { width: "100%" }]}>
                      <View style={[styles.blockInfoRow]}>
                        <Text style={[styles.footerInfo, { textAlign: isArabic(refactoredStore?.footerInfo) ? "right" : "left" }]}>
                          {/* {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.replacememtPolicyDesc} */}
                          {refactoredStore?.footerInfo}
                          {/* <Text style={[{ color: "#2D9CDB" }]}> www.premier.com/ReplacementPolicy </Text> */}
                        </Text>
                      </View>
                    </View>
                    {/* <View
                        style={[
                          styles.col_3_5,
                          styles.border,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "15" : "0",
                            marginRight: invoice?.selectedInvoiceLanguage === "ar" ? "15" : "0",
                          },
                        ]}
                      >
                        <View style={[styles.blockInfoRow]}>
                          <Text style={[styles.footerInfo]}>
                            {invoiceData?.invoiceData?.generalNotes ? invoiceData?.invoiceData?.generalNotes : ""}
                          </Text>
                        </View>
                      </View> */}
                    {/* <View
                        style={[
                          styles.col_3,
                          styles.border,
                          {
                            marginLeft: invoice?.selectedInvoiceLanguage === "en" ? "15" : "0",
                            marginRight: invoice?.selectedInvoiceLanguage === "ar" ? "15" : "0",
                          },
                        ]}
                      >
                        <View style={[styles.blockInfoRow]}>
                          <Text style={[styles.footerInfo]}>
                            {translateInvoicePdfData(invoice?.selectedInvoiceLanguage)?.termsAndCondDesc}
                            <Text style={[{ color: "#2D9CDB" }]}> www.premier.com/TermsAndConditions</Text>
                          </Text>
                        </View>
                      </View> */}
                  </View>
                ) : (
                  <Text></Text>
                )}

                {/* </View>  */}

                <View style={[styles.bottomRow, styles.footer]} fixed>
                  <Text
                    render={({ pageNumber, totalPages }) =>
                      `${invoice?.invoiceData?.invoiceType === "refund" ? "Refund Invoice No." : "Invoice No."}   ${
                        invoice?.invoiceData?.invoiceNumber
                      }, Page  ${pageNumber} / ${totalPages} \n ${invoice?.invoiceData?.invoiceType === "refund" ? "Reference Invoice No." : ""} ${
                        invoice?.invoiceData?.invoiceType === "refund" ? invoice?.invoiceData?.parentinvoiceNumber : ""
                      } `
                    }
                    fixed
                  />
                  {/* <Image style={[{ width: "23%" }]} src={IconFatoratyFooter} /> */}
                  <Image style={[{ width: "166px", height: "24px", objectFit: "contain" }]} src={IconFatoratyFooter} />
                  <Text render={({ pageNumber, totalPages }) => `${moment().format("ddd, DD MMM YYYY")} ${moment().format("HH:mm:ss")}`} />
                </View>
              </Page>
            </Document>
          </PDFViewer>
        )}
      </>
    ),
    // eslint-disable-next-line
    [companyData, invoiceData?.invoiceData, qrImage],
  );
};

export default PdfInvoicePage;
